class LogoutSignalService {
  private _isLoggingOut = false;

  signalLogout(): void {
    this._isLoggingOut = true;
  }

  signalLogin(): void {
    this._isLoggingOut = false;
  }

  get isLoggingOut(): boolean {
    return this._isLoggingOut;
  }
}

export const logoutSignalService = new LogoutSignalService();
